<div class="policy-category disabled">

  <div class="policy-item">
    <i class="policy-number">1</i>
    <div class="default-text large" [innerHTML]="textCopy.cancelPcnTitle"></div>
    <radio-question [data]="cancelPcn.data" [active]="cancelPcn.active"
                    [valueSelected]="cancelPcn.valueSelected"
                    (selectAnswer)="onCancelPcnSelected($event)"></radio-question>
    <br />
    <radio-question [data]="allContraventions.data" [active]="cancelPcn.valueSelected !== '2'"
                    [valueSelected]="allContraventions.valueSelected"
                    (selectAnswer)="onAllContraventionsSelected($event)"></radio-question>
    <br />
    <div class="default-text" [innerHTML]="textCopy.contraventionsTitle"></div>
    <contraventions-question [valuesSelected]="contraventionsQuestion.valuesSelected"
                    [options]="contraventionsQuestion.options"
                    (selectAnswer)="onContraventionsQuestionSelected($event)"
                    [active]="cancelPcn.valueSelected !== '2' && allContraventions.valueSelected === 'n'"></contraventions-question>
  </div>

  <br />
  <div class="submit-layer">
    <input aria-label=""  type="submit" class="app-submit" value="Save"
           (click)="submitPolicyCategory()" />
  </div>

</div>
